import { useQuery } from '@tanstack/react-query';
import userApi from '../services/userApi';

/**
 * useAccounts Hook - React Query integration for accounts list
 *
 * Features:
 * - Automatic caching (10-minute stale time)
 * - Auto-retry on network failures
 * - Alphabetical sorting (Arabic-aware)
 * - Consistent with bookings data fetching pattern
 *
 * Used by: AccountSwitcher component
 */
export const useAccounts = () => {
  return useQuery({
    queryKey: ['accounts'],
    queryFn: async () => {
      const response = await userApi.getAccounts();

      // Sort alphabetically (Arabic-aware)
      const accounts = response.users || [];
      return accounts.sort((a, b) => {
        // Arabic collation support
        return a.name.localeCompare(b.name, 'ar');
      });
    },
    staleTime: 10 * 60 * 1000,  // Cache for 10 minutes
    cacheTime: 15 * 60 * 1000,  // Keep in cache for 15 minutes
    retry: 2,  // Auto-retry twice on failure
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    onError: (error) => {
      console.error('Failed to fetch accounts:', error);
    }
  });
};

export default useAccounts;
